import carousel from '../modules/carousel';
export default {
    init() {},
    finalize() {
        carousel();
    },
};
